import { reservesConfig } from '../../../../config';
import { http } from '../../../../api/axios';
import { ReserveActionValue } from '../../constants';

export function includeOrExcludeAllReserveProducts(
    reserveListId: string,
    productId: string,
    action: ReserveActionValue
) {
    return http
        .put<void>(
            reservesConfig().endpointReserveProductAcceptReject,
            {},
            {
                params: {
                    action
                },
                pathParams: {
                    reserveListId,
                    productId
                }
            }
        )
        .then(response => response.data);
}
